












































































import { Component, Vue, PropSync } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required, requiredIf } from 'vuelidate/lib/validators';
import vSelect from 'vue-select';
import { AddressApi, OrgsApi } from '../../api';
import { Organisation } from '@/models/organisation';
import OrgSuggest from '@/components/form pickers/orgSuggest.vue';
import addressSuggest from '@/components/form pickers/adrSuggest.vue';
import { AxiosResponse } from 'axios';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		OrgSuggest,
		vSelect,
		addressSuggest,
		Toast,
	},
	validations: {
		localOrg: {
			id: {
				required: requiredIf(function() {
					return !!this.org.id;
				}),
			},
			name: { required },
			address: {
				fullAdr: {
					required: requiredIf(function() {
						return !this.org.id;
					}),
				},
				rawAddress: {
					required: requiredIf(function() {
						return !this.org.id;
					}),
				},
			},
		},
	},
	mixins: [validationMixin],
})
export default class AddOrg extends Vue {
	public existingSite = false;
	public emailRequired = true;
	public billingRequired = true;
	public loading = false;

	@PropSync('org') public localOrg!: Organisation;

	public billing: any = {
		organisationID: undefined,
		paymentMethod: '',
		directDebitDate: '',
		accountApproved: '',
	};

	public paymentMethodOptions = [
		{ value: 'farmSource', text: 'Farm Source' },
		{ value: 'ruralCo', text: 'Rural Co' },
		{ value: 'directDebit', text: 'Direct Debit' },
		{ value: 'directInvoice', text: 'Direct Invoice' },
	];

	public accountApprovedOptions = [
		{ value: 0, text: 'Not Approved' },
		{ value: 1, text: 'Approved' },
	];

	public $bvToast: any;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public region: any = null;
	public siteRegion: any = null;

	public isValid(field) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	public stepValidate(name: string) {
		const form = this.$v[name];
		form.$touch();
		if (!form.$invalid) {
			this.onComplete();
		}
	}

	public async onComplete(...a: any[]) {
		this.submitStatus = 'PENDING';

		const { existingOrg, ...org } = this.org; // ??

		org.org = this.localOrg;

		org.address = this.localOrg.address;
		try {
			const promise = await new OrgsApi().addOrg({ data: org });
			this.localOrg.id = promise.data.data.id;
		} catch (e) {
			let error;
			if (e.response) {
				if (e.response.data.message) {
					error = 'Organisation not created ' + e.response.data.message;
				} else {
					error = 'Organisation not created unknown error, check response';
				}
			} else if (e.request) {
				error = 'Organisation not created, network Error';
			} else {
				error = 'Organisation not created, unknown Error';
			}
			// const error = e.response.data.errors.name[0];
			new Toast().makeToast(error, 'Error Adding Organisation', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}

		try {
			await new AddressApi().addAddress({
				data: {
					ownerType: 'orgs',
					ownerId: this.localOrg.id,
					type: 'street',
					rawAddress: this.localOrg.address.rawAddress,
				},
			});
		} catch (e) {
			let error;
			if (e.response) {
				if (e.response.data.message) {
					error = 'Address not created: ' + e.response.data.message;
				} else {
					error = 'Address not created: unknown error, check response';
				}
			} else if (e.request) {
				error = 'Address not created: network Error';
			} else {
				error = 'Address not created: unknown Error';
			}
			new Toast().makeToast(error, 'Error Adding Address', 'danger', true);
			return;
		}

		try {
			await this.createOrdwayCustomer(org.name, parseInt(this.localOrg.id, 10));
		} catch (e) {
			new Toast().makeToast(
				'Please see the finance team, remember the name of this new org.',
				'Failed creating billing customer',
				'danger',
				true,
			);
			return;
		}

		new Toast().makeToast('Organisation Added', 'Organisation Added', 'success');

		this.submitStatus = 'OK';
		// this.$emit('input', this.localOrg);
		this.$emit('nextTab');
	}

	private async createOrdwayCustomer(organisationName: string, orgId: number): Promise<void> {
		await this.axios.post(
			process.env.VUE_APP_API_URL.replace(/\/+$/, '') + '/ordway/customer/create',
			{
				name: organisationName,
				tradingName: this.localOrg.tradingName,
				levnoOrgId: orgId,
			},
		);
	}
}
